import { Observable } from 'rxjs';

export abstract class KeyValueIDBStorage {
	abstract set<T = any>(key: string, data: T): Observable<T>;
	abstract setAnyway<T = any>(key: string, data: T): void;
	abstract get<T = any>(key: string): Observable<T>;
	abstract has(key: string): Observable<boolean>;
	abstract remove<T = any>(key: string): Observable<T>;
}
